import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Phone, Clock, ExternalLink } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PontosApoioWidget() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pontos-apoio/public`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!items.length) return null;

  return (
    <section className="bg-slate-50 border-t border-slate-200 py-14" data-testid="pontos-apoio-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-wider text-[#00883A] font-bold mb-1">
            Atendimento Presencial
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-3 flex items-center justify-center gap-3">
            <MapPin className="w-8 h-8 text-[#083CA6]" />
            Pontos de Apoio
          </h2>
          <p className="text-sm text-slate-600 max-w-2xl mx-auto">
            Precisa de ajuda com sua inscrição? Compareça a um de nossos pontos de atendimento
            presencial. Nossos agentes podem te auxiliar com o cadastro e envio de documentos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="pontos-apoio-grid">
          {items.map((p) => (
            <Card
              key={p.id}
              className="border-slate-200 hover:shadow-lg hover:border-[#083CA6]/30 transition-all overflow-hidden group"
              data-testid={`ponto-card-${p.id}`}
            >
              <div className="h-2 bg-gradient-to-r from-[#083CA6] to-[#00883A]" />
              <CardContent className="p-5">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-[#083CA6]/10 flex items-center justify-center shrink-0 group-hover:bg-[#083CA6] group-hover:text-white transition-colors">
                    <MapPin className="w-5 h-5 text-[#083CA6] group-hover:text-white" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-bold text-base text-slate-900 leading-tight" data-testid={`ponto-nome-${p.id}`}>
                      {p.nome}
                    </h3>
                    <p className="text-xs text-slate-500 mt-1">{p.endereco}</p>
                  </div>
                </div>

                <div className="space-y-1.5 text-xs text-slate-600 mb-4 ml-1">
                  {p.telefone && (
                    <div className="flex items-center gap-2">
                      <Phone className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                      <a href={`tel:${p.telefone.replace(/\D/g, "")}`} className="hover:text-[#083CA6]">
                        {p.telefone}
                      </a>
                    </div>
                  )}
                  {p.horario && (
                    <div className="flex items-start gap-2">
                      <Clock className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                      <span>{p.horario}</span>
                    </div>
                  )}
                </div>

                <a
                  href={p.maps_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#083CA6] text-white text-xs font-semibold px-3 py-2 rounded-md hover:bg-[#062f85] transition-colors w-full justify-center"
                  data-testid={`ponto-maps-${p.id}`}
                >
                  <MapPin className="w-3.5 h-3.5" />
                  Abrir no Google Maps
                  <ExternalLink className="w-3 h-3" />
                </a>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
